import { useState } from 'react';
import { monEspaceApi } from '../../api/resources';
import { tr, trf } from '../../lib/i18n';
import { C } from '../../theme/palette';

/** Ce que l'employé peut demander au bureau. */
export const DOCUMENTS_DEMANDABLES = [
  'Attestation de travail',
  'Certificat de salaire',
  'Certificat de travail intermédiaire',
  'Copie de mon contrat',
  'Copie d’une fiche de paie',
  'Autre document',
];

/**
 * « Demander un document au bureau » : la demande part dans son fil de
 * messages, où la cloche du bureau la signale.
 *
 * @param {{onEnvoye?: () => void}} props
 */
export function DemanderDocument({ onEnvoye }) {
  const [ouvert, setOuvert] = useState(false);
  const [quoi, setQuoi] = useState(DOCUMENTS_DEMANDABLES[0]);
  const [pourquoi, setPourquoi] = useState('');
  const [etat, setEtat] = useState(null);

  const envoie = () => {
    setEtat('envoi');
    const texte =
      '📄 ' +
      trf('Demande de document : {0}', tr(quoi)) +
      (pourquoi.trim() ? ' — ' + pourquoi.trim() : '');
    monEspaceApi
      .ecrit(texte)
      .then(() => {
        setEtat('ok');
        setPourquoi('');
        setOuvert(false);
        if (onEnvoye) onEnvoye();
      })
      .catch(() => setEtat('erreur'));
  };

  const champ = {
    width: '100%',
    boxSizing: 'border-box',
    border: '1px solid ' + C.border,
    borderRadius: 9,
    padding: 10,
    fontSize: 13,
    fontFamily: 'inherit',
    background: C.white,
  };

  return (
    <div style={{ marginTop: 12 }}>
      {etat === 'ok' && !ouvert && (
        <div
          role="status"
          style={{ fontSize: 12, color: C.green, fontWeight: 700, marginBottom: 8 }}
        >
          {tr('Demande envoyée. Le bureau la voit dans sa cloche.')}
        </div>
      )}
      {!ouvert ? (
        <button
          type="button"
          onClick={() => {
            setOuvert(true);
            setEtat(null);
          }}
          style={{
            width: '100%',
            minHeight: 44,
            borderRadius: 12,
            border: '1.5px solid ' + C.teal,
            background: C.white,
            color: C.teal,
            fontSize: 13,
            fontWeight: 800,
            cursor: 'pointer',
          }}
        >
          {tr('Demander un document au bureau')}
        </button>
      ) : (
        <div
          style={{
            border: '1px solid ' + C.border,
            borderRadius: 12,
            padding: 12,
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
          }}
        >
          <label
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 4,
              fontSize: 12,
              fontWeight: 700,
            }}
          >
            {tr('Quel document ?')}
            <select value={quoi} onChange={(e) => setQuoi(e.target.value)} style={champ}>
              {DOCUMENTS_DEMANDABLES.map((d) => (
                <option key={d} value={d}>
                  {tr(d)}
                </option>
              ))}
            </select>
          </label>
          <label
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 4,
              fontSize: 12,
              fontWeight: 700,
            }}
          >
            {tr('Pour quoi ? (facultatif)')}
            <input
              value={pourquoi}
              maxLength={300}
              onChange={(e) => setPourquoi(e.target.value)}
              placeholder={tr('Ex. pour un logement, pour la banque')}
              style={champ}
            />
          </label>
          {etat === 'erreur' && (
            <div role="alert" style={{ color: C.red, fontSize: 12 }}>
              {tr('Envoi impossible, réessaie.')}
            </div>
          )}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
            <button
              type="button"
              onClick={() => setOuvert(false)}
              style={{
                minHeight: 44,
                borderRadius: 10,
                border: '1px solid ' + C.border,
                background: C.white,
                fontWeight: 700,
                cursor: 'pointer',
              }}
            >
              {tr('Annuler')}
            </button>
            <button
              type="button"
              disabled={etat === 'envoi'}
              onClick={envoie}
              style={{
                minHeight: 44,
                borderRadius: 10,
                border: 'none',
                background: C.teal,
                color: C.white,
                fontWeight: 800,
                cursor: 'pointer',
              }}
            >
              {tr('Envoyer la demande')}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
